import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';
import { Rol,RolSimple, RolPagination } from './rol.type';
import { User } from '../../users/services/users.types';

@Injectable({
  providedIn: 'root'
})
export class RolService {
  private baseUrl: string;
  private _roles: BehaviorSubject<Rol[] | null> = new BehaviorSubject(null);
  private _rolesSimple : BehaviorSubject<any[] | null> = new BehaviorSubject(null);
  private _pagination: BehaviorSubject<RolPagination | null> = new BehaviorSubject(null);
  private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
  private _rolSelection: BehaviorSubject<Rol | null> = new BehaviorSubject(null);

  constructor(
    private httpClient: HttpClient
  ) {
    this.baseUrl = `${environment.apiURL}/roles-managment`
  }

  get rol$(): Observable<Rol[]> {
    return this._roles.asObservable();
  }

  get listRol$():Observable<RolSimple[]>{
    return this._rolesSimple.asObservable();
  }

  get pagination$(): Observable<RolPagination> {
    return this._pagination.asObservable();
  }

  get detailrol(): Observable<Rol> {
    return this._rolSelection.asObservable();
  }

  list(page: number = 0, size: number = 10, sort: string = 'name', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
    Observable<RolPagination> {
    const endpoint: string = this.baseUrl + '/roles';

    return this.httpClient.get<RolPagination>(endpoint, {
      params: {
        page: '' + page,
        size: '' + size,
        sort,
        order,
        search
      }
    }).pipe(tap((res) => {
      /*let data: Rol[] = [];
      for (let index in res.data) data.push(res.data[index]);*/

      res.data.forEach(item => {
        item.cheked = false;
        item.open = false;
      });

      this._pagination.next(res);
      this._roles.next(res.data);
    }));
  }

  save(data: any) {
    const endpoint: string = this.baseUrl + '/roles';
    return this.httpClient.post(endpoint, data);
  }

  get(): Observable<User> {
    const endpoint: string = `${environment.apiURL}/common`
    return this.httpClient.get<User>(endpoint + '/user')
  }

  listSimple():Observable<RolSimple[]>{
    const endpoint: string = this.baseUrl + '/roles/simple';
    return this.httpClient.get<RolSimple[]>(endpoint).pipe(tap((res)=>{
        const roles=res.filter(rol=>{
            return rol.name!='Administrador';
        })
        this._rolesSimple.next(roles);
    }));
  }

  detail(id: number){
    const endpoint: string = this.baseUrl + '/information/' + id;
    return this.httpClient.get<Rol>(endpoint);
  }

  update(data: any, id: number){
    const endpoint: string = this.baseUrl + '/roles/' + id;
    return this.httpClient.put(endpoint, data);
  }

  setdetail(rol: Rol) {
    this._rolSelection.next(rol);
  }

  delete(id: number) {
    const endpoint: string = this.baseUrl + '/roles/' + id;
    return this.httpClient.delete(endpoint);
  }

}
